import { api } from "./client";

export function getPlan({ signal } = {}) {
  return api("/api/plan", { signal });
}

export function approvePlan(brandId, { signal } = {}) {
  return api("/api/plan/approve", { method: "POST", signal, json: { brand_id: brandId || undefined } });
}

export function executeTask(taskId, { signal } = {}) {
  return api(`/api/plan/${encodeURIComponent(taskId)}/execute`, { method: "POST", signal, json: {} });
}

export function getTaskExecution(jobId, { signal } = {}) {
  return api(`/api/plan/executions/${encodeURIComponent(jobId)}`, { signal });
}

export function listTaskExecutions({ signal } = {}) {
  return api("/api/plan/executions", { signal });
}

export function provideTask(taskId, lang, { signal } = {}) {
  return api(`/api/plan/${encodeURIComponent(taskId)}/provide`, { method: "POST", signal, json: { lang } });
}

export function setTaskStatus(taskId, status, { signal } = {}) {
  return api(`/api/plan/${encodeURIComponent(taskId)}/status`, { method: "POST", signal, json: { status } });
}
